import { Modal } from "antd";

export const confirmUnshareWidget = ({ isShared, widgetName = "this widget" }) => {
  if (!isShared) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    Modal.confirm({
      title: "Unshare widget",
      content: `Are you sure you want to unshare ${widgetName}?`,
      okText: "Yes, unshare",
      cancelText: "Cancel",
      zIndex: "9999999999999999",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};
